export default {
    extraLarge: 30,
    large: 20,
    medium: 10,
    small: 5,
    none: 0
}